module.exports = __webpack_public_path__ + "img/glass-unknown.fe06e0c.svg";